import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CallerInfo from '../CallerInfo';
import CallerTypePanel from '../CallerTypePanel';
import ClaimInfo from '../ClaimInfo';
import TitleBar from '../TitleBar';
import TabPanel from '../TabPanel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Survey from '../Survey';
import './InfoTab.css';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const MyTab = styled(Tab)({
  fontFamily: 'Open Sans',
  fontWeight: '600',
  color: '#FFFFFF',
  // position: 'absolute',
  right: '0'
});

const styles = {
  tabPanel: {
    height: '100%'
  }
};

const InfoTab = props => {
  //Used to keep track of currently selected tab
  const [value, setValue] = useState(props.infoTabSelected);

  //Survey Values
  const [step, setStep] = useState(1);
  
  // Helper function to get survey response for current contact
  const getCurrentSurveyResponse = () => {
    return props.surveyResponses.find(
      response => response.contactId === props.contactAttributes.contactId
    );
  };

  const [generalDetails, setGeneralDetails] = useState(
    getCurrentSurveyResponse()?.responses?.generalDetails || ''
  );
  const [taskDetails, setTaskDetails] = useState(
    getCurrentSurveyResponse()?.responses?.taskDetails || ''
  );
  const [surveyCallReasonValues, setSurveyCallReasonValues] = useState(
    getCurrentSurveyResponse()?.responses?.callReasons || ''
  );
  const [note, setNote] = useState(
    getCurrentSurveyResponse()?.responses?.note || ''
  );
  const [primaryCallReason, setPrimaryCallReason] = useState(
    getCurrentSurveyResponse()?.responses?.primaryCallReason || ''
  );
  const [additionalDetails, setAdditionalDetails] = useState(
    getCurrentSurveyResponse()?.responses?.additionalDetails || ''
  );
  const [notes, setNotes] = useState(
    getCurrentSurveyResponse()?.responses?.notes || ''
  );
  const [addNotesList, setAddNotesList] = useState(
    getCurrentSurveyResponse()?.responses?.addNotesList || []
  );
  const [inputList, setInputList] = useState(
    getCurrentSurveyResponse()?.responses?.inputList || []
  );
  const [submitted, setSubmitted] = useState(
    getCurrentSurveyResponse()?.responses?.submitted || false
  );
  const [selected, setSelected] = useState(
    getCurrentSurveyResponse()?.responses?.selected || ''
  );
  const [showPrimaryReasons, setShowPrimaryReasons] = useState(true);

  useEffect(() => {
    setValue(props.infoTabSelected);
  }, [props.infoTabSelected]);

  // Reset local survey state when the active contact changes
  useEffect(() => {
    const response = getCurrentSurveyResponse()?.responses;
    setGeneralDetails(response?.generalDetails || '');
    setTaskDetails(response?.taskDetails || '');
    setSurveyCallReasonValues(response?.callReasons || '');
    setNote(response?.note || '');
    setPrimaryCallReason(response?.primaryCallReason || '');
    setAdditionalDetails(response?.additionalDetails || '');
    setNotes(response?.notes || '');
    setAddNotesList(response?.addNotesList || []);
    setInputList(response?.inputList || []);
    setSubmitted(response?.submitted || false);
    setSelected(response?.selected || '');
    setStep(1);
  }, [props.contactAttributes.contactId]);
  
  useEffect(() => {
    const contactResponses = {
      contactId: props.contactAttributes.contactId,
      responses: {
        generalDetails: { ...generalDetails },
        callReasons: [...surveyCallReasonValues],
        primaryCallReason: primaryCallReason,
        taskDetails: { ...taskDetails },
        note: note, 
        additionalDetails: additionalDetails,
        notes: notes,
        addNotesList: addNotesList,
        inputList: inputList,
        selected: selected,
        submitted: submitted,
      }
    };
    props.setSurveyResponses(prevResponses => [
      ...prevResponses.filter(
        response => response.contactId !== contactResponses.contactId
      ),
      contactResponses
    ]);
  }, [
    generalDetails,
    surveyCallReasonValues,
    taskDetails,
    note,
    primaryCallReason,
    additionalDetails,
    notes,
    //surveyAdditionalNotesValues,
    addNotesList,
    inputList,
    selected,
    submitted,
  ]);

  const handleChange = (event, newValue) => {
    props.setInfoTabSelected(newValue);
    setValue(newValue);
  };

  return (
    <div
      id="info-tab"
      className="container"
      style={
        props.contactAttributes.borderColor
          ? {
              border: '5px solid ' + props.contactAttributes.borderColor,
            }
          : {}
      }
    >
      {/* This is needed so we can tell Verint to record chats */}
      <select
        id="verintStatus"
        name="verintStatus"
        style={{ display: 'none' }}
        value={props.showVerintIdentifier ? 'connect' : 'disconnect'}
      >
        <option value="disconnect">disconnect</option>
        <option value="connect">connect</option>
      </select>
      <Box sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backgroundColor: 'white'
      }}>
        <div
          id="DivTest"
          style={{
            width: '100%',
            display: 'flex',
            backgroundColor: '#4A4A4A',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px'
          }}
        >
          <TitleBar title={value === 0 ? 'Details' : 'Call Reporting'} />
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs"
            textColor="#FFFFFF"
            indicatorHeight={10}
            TabIndicatorProps={{
              style: {
                background: '#FFFFFF',
                textColor: '#4A4A4A',
                width: '50%'
              }
            }}
          >
            <MyTab icon={<PersonIcon />} className={'test fs-unmask'} {...a11yProps(0)} />
            <MyTab
              icon={<AssignmentIcon />}
              className={'test fs-unmask'}
              {...a11yProps(1)}
            />
          </Tabs>
        </div>
      </Box>
      <div
        className="infoTabButtonBar"
        style={
          props.contactAttributes.borderColor
            ? {
                borderBottom:
                  '5px solid ' + props.contactAttributes.borderColor,
              }
            : {}
        }
      >
        {props.contacts
          .filter((c) => c.attributes.typeId === 'Chat')
          .map((contact) => (
            <button
              key={contact.attributes.contactId}
              className="infoTabButton"
              style={{
                background: contact.attributes.borderColor,
                fontWeight:
                  contact.attributes.contactId ===
                  props.contactAttributes.contactId
                    ? '750'
                    : 'none',
                textDecoration:
                  contact.attributes.contactId ===
                  props.contactAttributes.contactId
                    ? 'underline'
                    : 'none',
              }}
              onClick={() =>
                props.handleInfoTabContactViewedFunction(
                  contact.attributes.contactId,
                )
              }
            >
              {contact.attributes.firstName?.value ?? 'Unknown'}{' '}
              {contact.attributes.lastName?.value ?? 'Unknown'}
            </button>
          ))}
      </div>
      <TabPanel value={value} index={0}>
        {/* <TitleBar title="Details" /> */}
        <CallerTypePanel contactAttributes={props.contactAttributes} />
        {props.contactAttributes.callerType?.value === 'Claimant' ||
        props.contactAttributes.chatTopic || 
        props.contactAttributes.contactId ? (
          <div>
            <CallerInfo contactAttributes={props.contactAttributes} />
            <hr className="hr" />
            <ClaimInfo contactAttributes={props.contactAttributes} />
          </div>
        ) : (
          ''
        )}
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        style={{ height: '100%' }}
        classes={{ root: styles.tabPanel }}
      >
        <Survey
          contactAttributes={props.contactAttributes}
          step={step}
          setStep={setStep}
          generalDetails={generalDetails}
          setGeneralDetails={setGeneralDetails}
          surveyCallReasonValues={surveyCallReasonValues}
          setSurveyCallReasonValues={setSurveyCallReasonValues}
          note={note}
          setNote={setNote}
          primaryCallReason={primaryCallReason}
          setPrimaryCallReason={setPrimaryCallReason}
          calls={props.calls}
          chats={props.chats}
          failureTask={props.failureTask}
          callbackTask={props.callbackTask}
          intermittentAbsenceTask={props.intermittentAbsenceTask}
          requestTypeOptions={props.requestTypeOptions}
          workItemTypeOptions={props.workItemTypeOptions}
          callerTypeOptions={props.callerTypeOptions}
          caseIds={props.caseIds}
          taskDetails={taskDetails}
          setTaskDetails={setTaskDetails}
          surveyResponses={props.surveyResponses}
          showPrimaryReasons={showPrimaryReasons}
          setShowPrimaryReasons={setShowPrimaryReasons}
          setAdditionalDetails={setAdditionalDetails}
          additionalDetails={additionalDetails}
          setNotes={setNotes}
          notes={notes}
          setInputList={setInputList}
          inputList={inputList}
          setAddNotesList={setAddNotesList}
          addNotesList={addNotesList}
          selected={selected}
          setSelected={setSelected}
          submitted={submitted}
          setSubmitted={setSubmitted}
        />
      </TabPanel>
    </div>
  );
};

InfoTab.propTypes = {
  infoTabSelected: PropTypes.number.isRequired,
  setInfoTabSelected: PropTypes.func.isRequired,
  contactAttributes: PropTypes.shape({
    contactId: PropTypes.string,
    borderColor: PropTypes.string,
    callerType: PropTypes.shape({
      value: PropTypes.string,
    }),
    chatTopic: PropTypes.string,
  }).isRequired,
  contacts: PropTypes.arrayOf(PropTypes.shape({
    attributes: PropTypes.shape({
      contactId: PropTypes.string,
      typeId: PropTypes.string,
      borderColor: PropTypes.string,
      firstName: PropTypes.shape({
        value: PropTypes.string,
      }),
      lastName: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  })).isRequired,
  handleInfoTabContactViewedFunction: PropTypes.func.isRequired,
  showVerintIdentifier: PropTypes.bool.isRequired,
  surveyResponses: PropTypes.arrayOf(PropTypes.shape({
    contactId: PropTypes.string,
    responses: PropTypes.shape({
      generalDetails: PropTypes.object,
      callReasons: PropTypes.array,
      primaryCallReason: PropTypes.string,
      taskDetails: PropTypes.object,
      note: PropTypes.string,
      additionalDetails: PropTypes.string,
      notes: PropTypes.string,
      addNotesList: PropTypes.array,
      inputList: PropTypes.array,
      selected: PropTypes.string,
      submitted: PropTypes.bool,
    }),
  })).isRequired,
  setSurveyResponses: PropTypes.func.isRequired,
  calls: PropTypes.object,
  chats: PropTypes.object,
  failureTask: PropTypes.object,
  callbackTask: PropTypes.object,
  intermittentAbsenceTask: PropTypes.object,
  requestTypeOptions: PropTypes.array,
  workItemTypeOptions: PropTypes.array,
  callerTypeOptions: PropTypes.array,
  caseIds: PropTypes.array,
};

export default InfoTab;
